import Vue from 'vue';
import Router from 'vue-router';
import client from '@/utilities/client.js';
import SignIn from '@/components/SignIn';
import SelectBox from '@/components/SelectBox';
import SelectRoute from '@/components/SelectRoute';
import StartCheck from '@/components/StartCheck';
import NormalTemperatureCount from '@/components/NormalTemperatureCount';
import NormalTemperatureDelivery from '@/components/NormalTemperatureDelivery';
import RefrigeratedCount from '@/components/RefrigeratedCount';
import RefrigeratedDelivery from '@/components/RefrigeratedDelivery';
import FinalCheck from '@/components/FinalCheck';
import Finish from '@/components/Finish';
import MaintenanceCheck from '@/components/MaintenanceCheck';
import LossCheck from '@/components/LossCheck';
import TakeoutCheck from '@/components/TakeoutCheck';
import CommentList from '@/components/CommentList';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'SelectBox',
    component: SelectBox,
    meta: { requiresAuth: true },
  },
  {
    path: '/sign-in',
    name: 'SignIn',
    component: SignIn,
  },
  {
    path: '/select-route',
    name: 'SelectRoute',
    component: SelectRoute,
  },
  {
    path: '/start-check',
    name: 'StartCheck',
    component: StartCheck,
  },
  {
    path: '/normal-temperature-count',
    name: 'NormalTemperatureCount',
    component: NormalTemperatureCount,
  },
  {
    path: '/normal-temperature-delivery',
    name: 'NormalTemperatureDelivery',
    component: NormalTemperatureDelivery,
  },
  {
    path: '/refrigerated-count',
    name: 'RefrigeratedCount',
    component: RefrigeratedCount,
  },
  {
    path: '/refrigerated-delivery',
    name: 'RefrigeratedDelivery',
    component: RefrigeratedDelivery,
  },
  {
    path: '/final-check',
    name: 'FinalCheck',
    component: FinalCheck,
  },
  {
    path: '/finish',
    name: 'Finish',
    component: Finish,
  },
  {
    path: '/maintenance-check',
    name: 'MaintenanceCheck',
    component: MaintenanceCheck,
  },
  {
    path: '/loss-check',
    name: 'LossCheck',
    component: LossCheck,
  },
  {
    path: '/takeout-check',
    name: 'TakeoutCheck',
    component: TakeoutCheck,
  },
  {
    path: '/comment-list',
    name: 'CommentList',
    component: CommentList,
  },
];

const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior() {
    document.getElementsByClassName('main-content')[0].scrollTop = 0;
    return { x: 0, y: 0 };
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    client.get('/token/valid.json')
      .then(() => {
        next();
      })
      .catch((e) => {
        alert(e.response.data.error.message);
        next({ name: 'SignIn', replace: true });
      });
  }
  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js